<template>
  <div>
    <el-dialog
      title="Change Password"
      :visible.sync="changePasswordVisible"
      width="380px"
      :before-close="onClose"
    >
      <el-form
        ref="form"
        :model="form"
        size="medium"
        v-loading="loading"
        @submit.prevent.native="changePassword"
        element-loading-text="Verifying..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
      >
        <el-form-item>
          <el-input
            placeholder="Current password"
            v-model="form.oldPassword"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="New password"
            v-model="form.newPassword"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="Confirm password"
            v-model="form.confirmPassword"
            show-password
          ></el-input>
        </el-form-item>
        <div class="password-warning">
            <span>Note: Password must be minimum eight characters, </span><br>
            <span>at least one letter and one number.</span>
        </div>  
        <div style="text-align: center;margin: 30px 0 0 0;display:inline">
          <el-form-item>
            <el-button @click="onClose">Cancel</el-button>
            <el-button type="primary" @click="changePassword"
              >Confirm</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { showMessage } from "../utils";
import { mapState } from "vuex";

export default {
  name: "Password",
  data: function() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    changePassword() {
      this.$store.commit("user/setAuthLoading", true);
      if (
        this.form.newPassword === this.form.confirmPassword &&
        this.form.oldPassword !== this.form.confirmPassword
      ) {
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/
        if(!passwordRegex.test(this.form.newPassword)){
            showMessage('Password doesn’t meet minimum requirements', 'error')
            this.$store.commit("user/setAuthLoading", false);
            return;
        }
        this.$store.dispatch("user/changePassword", {
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword,
        });
      } else {
        const message =
          this.form.oldPassword !== this.form.confirmPassword
            ? "New Password and Confirm password do not match"
            : "New password cannot be same as old password";
        showMessage(message, 'error')
      }
      this.$store.commit("user/setAuthLoading", false);
      this.$store.commit('user/setChangePassword', false);
    },
    onClose() {
      this.$store.commit('user/setChangePassword', false);
      this.form = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.user.authLoading,
      changePasswordVisible: (state) => state.user.changePassword
    }),
  },
};
</script>

<style scoped>
.password-warning{
    font-size:100%;
    padding-bottom:10px;
    text-align: center;
    word-break: break-word;

}
@media (max-width: 380px) {
    >>>.el-dialog{
        width: calc(100% - 30px) !important;
    }
}
</style>